// Same format as the self-checkout (`organisations/utils/tel-regex.ts`) and the backend, written without its nested
// quantifiers – those backtrack exponentially and freeze the tab on a long input.
const PHONE_PATTERN = /^\+?(?:\d|\(\d+\))[\d()-]*\d$/;
const PHONE_MAX_LENGTH = 30;

/** Spaces may be typed – the backend stores the number without them. */
export const isValidPhone = (value: string): boolean => {
  const compact = value.replace(/\s/g, '');
  return compact.length <= PHONE_MAX_LENGTH && PHONE_PATTERN.test(compact);
};
